// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-drop-zone {
    border: 2px dashed #cbd5e0;
    border-radius: 8px;
    padding: 3rem 2rem;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #f8f9fa;
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.file-drop-zone:hover {
    border-color: #4299e1;
    background-color: #ebf8ff;
}

.file-drop-zone.dragging {
    border-color: #3182ce;
    background-color: #bee3f8;
    transform: scale(1.02);
}

.drop-zone-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.selected-file-preview {
    width: 100%;
}

.file-info {
    display: flex;
    align-items: center;
    padding: 1rem;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.file-details {
    flex: 1;
}

.file-details h6 {
    font-weight: 600;
    color: #2d3748;
    margin-bottom: 0.25rem;
}

.modal-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
}

.modal-title {
    font-weight: 600;
    color: #2d3748;
}

.modal-footer {
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
}

/* RTL Support */
[dir="rtl"] .file-info i {
    margin-right: 0;
    margin-left: 1rem;
}

[dir="rtl"] .file-info .btn {
    margin-left: 0;
    margin-right: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/attach-file-modal/attach-file-modal.component.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".file-drop-zone {\n    border: 2px dashed #cbd5e0;\n    border-radius: 8px;\n    padding: 3rem 2rem;\n    text-align: center;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    background-color: #f8f9fa;\n    min-height: 300px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.file-drop-zone:hover {\n    border-color: #4299e1;\n    background-color: #ebf8ff;\n}\n\n.file-drop-zone.dragging {\n    border-color: #3182ce;\n    background-color: #bee3f8;\n    transform: scale(1.02);\n}\n\n.drop-zone-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.selected-file-preview {\n    width: 100%;\n}\n\n.file-info {\n    display: flex;\n    align-items: center;\n    padding: 1rem;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.file-details {\n    flex: 1;\n}\n\n.file-details h6 {\n    font-weight: 600;\n    color: #2d3748;\n    margin-bottom: 0.25rem;\n}\n\n.modal-header {\n    background-color: #f8f9fa;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.modal-title {\n    font-weight: 600;\n    color: #2d3748;\n}\n\n.modal-footer {\n    background-color: #f8f9fa;\n    border-top: 1px solid #dee2e6;\n}\n\n/* RTL Support */\n[dir=\"rtl\"] .file-info i {\n    margin-right: 0;\n    margin-left: 1rem;\n}\n\n[dir=\"rtl\"] .file-info .btn {\n    margin-left: 0;\n    margin-right: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
